import React, { memo, useEffect, useState } from "react";
import { FiMenu } from "react-icons/fi";
import { useNavigate, Link } from "react-router-dom";
import { sidebarItems } from "./SidebarData";
import Navbar from "./Navbar";

const Sidebar = ({ children }) => {
  const [toggle, setToggle] = useState(false);
  const [submenuIndex, setSubmenuIndex] = useState(null);

  const navigate = useNavigate();

  const handleToggle = () => setToggle((prev) => !prev);

  const handleLogout = () => {
    localStorage.removeItem("staffToken");
    localStorage.removeItem("staffData");
    navigate("/");
    window.location.reload();
  };

  const handleSubmenuClick = (index) => {
    setSubmenuIndex(submenuIndex === index ? null : index);
  };

  /* Hover effect only when sidebar collapsed */
  useEffect(() => {
    const asideBody = document.querySelector(".aside-body");
    const asideEle = document.querySelector("aside");

    const enter = () => {
      if (asideEle.classList.contains("activeToggle")) {
        asideBody.classList.add("hoverAsideBody");
      }
    };
    const leave = () => asideBody.classList.remove("hoverAsideBody");

    asideBody.addEventListener("mouseenter", enter);
    asideBody.addEventListener("mouseleave", leave);

    return () => {
      asideBody.removeEventListener("mouseenter", enter);
      asideBody.removeEventListener("mouseleave", leave);
    };
  }, [toggle]);

  return (
    <>
      <aside className={`sidebarContainer ${toggle ? "activeToggle" : ""}`}>
        {/* HEADER */}
        <header className="asideheader">
          {!toggle && (
            <img
              style={{ padding: "12px", height: "67px" }}
              onClick={() => navigate("/")}
              src="https://static.wixstatic.com/media/5715af_a286bfb446374a96877a4193a1ef0933~mv2.png/v1/fill/w_114,h_60,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/PAT%20Logo.png"
              alt="Logo"
            />
          )}

          <button className="toggle-menu-btn" onClick={handleToggle}>
            <FiMenu />
          </button>
        </header>

        {/* BODY */}
        <div className="aside-body">
          <div className="scrollbar">
            <div className="scroll-container">
              <div className="aside-inner-body">
                {/* USER SECTION */}
                <div className="aside-user">
                  <div className="user-info">
                    <div className="avatar">
                      <span className="avatar-inital">A</span>
                    </div>
                    {!toggle && <span className="admintext">Administrator</span>}

                    {/* ICONS */}
                    <div className="aside-alerts">
                      <div className="react-component-tooltip">
                        {/* Logout */}
                        <div className="tooltip_element" onClick={handleLogout}>
                          <a href="#" className="icon-header">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2.3"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                              <polyline points="16 17 21 12 16 7"></polyline>
                              <line x1="21" y1="12" x2="9" y2="12"></line>
                            </svg>
                          </a>
                          <span className="tooltip signout">Sign out</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* NAVIGATION */}
                <ul className={toggle ? "aside-navbar" : "aside-navbar11"}>
                  {sidebarItems.map((group, i) => (
                    <li key={i} className="aside-nav-item-li">
                      <Link to="#" className="aside-navbar-heading">
                        {group.title}
                      </Link>

                      <ul className="submenu">
                        {group.dataUl.map((item, idx) => {
                          const isOpen = submenuIndex === idx;

                          return (
                            <li
                              key={idx}
                              className={`${item.ulItems ? "with-sub" : "witout-sub"} ${
                                isOpen ? "open" : ""
                              }`}
                              onClick={
                                item.ulItems
                                  ? () => handleSubmenuClick(idx)
                                  : undefined
                              }
                            >
                              <Link className="aside-navbar-link" to={item.pasths}>
                                {item.ulIcon}
                                <span>{item.name}</span>
                              </Link>

                              {/* Submenu */}
                              {item.ulItems && (
                                <ul
                                  className={`mega-submenu ${
                                    isOpen ? "open" : ""
                                  }`}
                                >
                                  {item.ulItems.map((sub, subIdx) => (
                                    <li key={subIdx}>
                                      <Link className="aside-navbar-link" to="#">
                                        {sub}
                                      </Link>
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </li>
                          );
                        })}
                      </ul>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </aside>

      {/* MAIN CONTENT RENDER */}
       <div className="containerNormal mainContainerlarge"> 
                             <Navbar />

       <div className="contain-body"> 
                <div className="containerInside">
                   <div className="container-inside-body"> 
      <main>{children}</main>
                         </div>
                      </div>
                    </div>
                             </div>
   </> 
  );
};

export default memo(Sidebar);
